//Vistas del main layout:
import LoginForm from '../components/LoginForm';
import PasswordReset from '../components/PasswordReset';
import DownloadReportPage from '../../../views/DownloadReportPage';

let authMenuRoutes = [
    {
        path: "/login",
        name: "Login",
        subname: "Login",
        icon: "nc-icon nc-book-bookmark",
        component: LoginForm,
        layout: "/auth",
        adminRequired: false
    },
    {
        path: "/passwordReset",
        name: "Password Reset",
        subname: "Password Reset",
        icon: "nc-icon nc-book-bookmark",
        component: PasswordReset,
        layout: "/auth",
        adminRequired: false
    },
    {
        path: "/download-report",
        name: "Download Report",
        subname: "Download Report",
        icon: "nc-icon nc-cloud-download-93",
        component: DownloadReportPage,
        layout: "/auth",
        adminRequired: false
    }
];

export default authMenuRoutes;
